/*global Gumshoe */

var toc = {
    spy: false,
    availableSpace: parseInt($('#toc-nav').width()) - parseInt($('#toc-more-action').width()),
    init: function() {
        toc.list();
        toc.scrollspy();
        toc.openInitialItem();
    },
    list: function() {
        var documentRef = document;
        var toc = documentRef.getElementById('toc');
        var headings = [].slice.call($('.main-wrapper h2'));
        headings.forEach(function(heading, index) {
            var link = documentRef.createElement('a');
            link.setAttribute('href', '#toc-' + index);
            link.textContent = heading.textContent;

            var list = documentRef.createElement('li');
            list.setAttribute('class', 'toc-item');

            list.appendChild(link);
            toc.appendChild(list);
            heading.setAttribute('id', 'toc-' + index);
        });

        this.updateNav();
        this.moreNav();
    },

    openInitialItem: function() {
        if (window.location.hash.length > 0) {
            const section= window.location.hash.split('#')[1];
            toc.openItem(section);
        }
    },
    updateNav: function() {

        var navWidth = 0,
            tocList = $('#toc > li');

        tocList.each(function() {
            navWidth += parseInt($(this).outerWidth(true));
        });

        if (navWidth > toc.availableSpace) {
            var lastItem = tocList.last();
            $('#toc-more').prepend(lastItem);
            toc.updateNav();
        }
    },
    openItem: function(id) {
        var tocElement = $('#' + id);

        if (tocElement.is(':hidden')) {
            var openTab = tocElement.data('tab');
            $('.open-tab.' + openTab + ' a').click();
            toc.spy.setup();
        }

        $('#toc-more-action').removeClass('opened');
        $('#toc-more').hide();

        $('html, body').animate({
            scrollTop: tocElement.offset().top - 85
        }, 400);
    },
    moreNav: function() {
        $('#toc-more-action').on('click', function(e) {
            e.stopPropagation();
            $(this).toggleClass('opened');
            $('#toc-more').toggle();
        });

        $('#toc-more').on('click', function(e) {
            e.stopPropagation();
        });

        $('.toc-item a').on('click', function() {
            const id = $(this).attr('href').replace('#', '');
            toc.openItem(id);
        });
    },
    scrollspy: function() {
        toc.spy = new Gumshoe('#toc a', {
            nested: true,
            offset: function() {
                return 120;
            }
        });
        //spy.detect();
    }
};
